module.exports = __webpack_public_path__ + "img/production-active.59136bbc.svg";